<template lang="pug">
  #OrderOnlineList
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 顧客個人預選清單
    .container-width
      .p-3
        b-card.mb-1.customerCard.overflow-hidden
          .row.align-items-center.pb-1.no-gutters
            .col-3.pr-2
              ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                :profileUrl="member.picture_url",
                :style="{ 'width': '70px', 'height': '70px' }"
              )
            .col-9.pl-1
              p.mb-0.font-weight-bold {{ member.line_display_name }}
              p.mb-0.text-gray {{ member.note_name ? member.note_name : '-' }}
              p.mb-0 預選清單數：{{ list.length }}
      .p-3.px-5
        b-card.border-0.mb-1.overflow-hidden(
          bg-variant="white",
          v-for="(user,index) in list",
          :key="user.member_id",
          body-class="p-0"
        )
          .row.align-items-center.mb-2.pb-2.no-gutters(
            :class="{ 'border-bottom border-grey': index + 1 !== list.length }"
          )
            .pl-6
              p.mb-0 活動名稱：{{ user.event_name }}
              p.mb-0 預選時間： {{ user.created_at }}
              p.mb-0 預選櫃點：{{ user.store }}
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';

export default {
  name: 'OrderOnlineList',
  components: {
    ProfilePhotoSticker,
  },
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
    };
  },
  mounted() {
    const vm = this;
    vm.initHandler();
  },
  methods: {
     initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sa_order_online/getDataHandler',{
        line_uuid: vm.userId
      })
        .then(() => {
          vm.$swal.close();
        });
     },
  },
  computed: {
    ...mapState({
      member: (state) => state.sa_order_online.member.member,
      list: (state) => state.sa_order_online.member.list,
    })
  },
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}
.customerCard {
  border: 0.2rem solid #000;
    border-radius: 0.8rem;
    box-shadow: 0.2rem 0.2rem 0 #00000033;
}
</style>
